import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Subject } from "rxjs/internal/Subject";

@Injectable()

export class DataCommunicatorService {

  public menuKey: Subject<number> = new BehaviorSubject<number>(0);
  public selectedItem: Subject<any> = new BehaviorSubject<any>(null);
  public historyFlyoutData : Subject<any> = new BehaviorSubject<any>(null);

  addNode(data: number) {
    this.menuKey.next(data);
  }

  showHistoryFlyout(data: any) {
    this.historyFlyoutData.next(data)
  }
}
